import { apiClient } from '../api';
import type {
    ProviderFeeInvoice,
    ProviderFeeInvoiceFilters,
    ProviderFeeInvoiceListResponse,
    ProviderFeeInvoicePrepareData,
} from '../../types';

export async function listProviderFeeInvoices(filters: ProviderFeeInvoiceFilters): Promise<ProviderFeeInvoiceListResponse> {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== '' && value !== 'all') params.set(key, String(value));
    });
    const query = params.toString();
    return apiClient.get<ProviderFeeInvoiceListResponse>(`/api/admin/provider-fee-invoices${query ? `?${query}` : ''}`);
}

export async function prepareProviderFeeInvoice(contractId: number): Promise<ProviderFeeInvoicePrepareData> {
    const response = await apiClient.get<{ data: ProviderFeeInvoicePrepareData }>(
        `/api/admin/provider-fee-invoices/contracts/${contractId}/prepare`,
    );
    return response.data;
}

export async function stampProviderFeeInvoice(
    contractId: number,
    payload: { payment_form: string; cfdi_use: string },
): Promise<ProviderFeeInvoice> {
    const response = await apiClient.post<{ data: ProviderFeeInvoice }>(
        `/api/admin/provider-fee-invoices/contracts/${contractId}/stamp`,
        payload,
    );
    return response.data;
}

export async function getProviderFeeInvoice(invoiceId: number): Promise<ProviderFeeInvoice> {
    const response = await apiClient.get<{ data: ProviderFeeInvoice }>(
        `/api/admin/provider-fee-invoices/${invoiceId}`,
    );
    return response.data;
}

export async function retryProviderFeeInvoice(invoiceId: number): Promise<ProviderFeeInvoice> {
    const response = await apiClient.post<{ data: ProviderFeeInvoice }>(
        `/api/admin/provider-fee-invoices/${invoiceId}/retry`,
        {},
    );
    return response.data;
}

export async function downloadProviderFeeInvoiceXml(invoiceId: number): Promise<Blob> {
    const { blob } = await apiClient.getBlob(`/api/admin/provider-fee-invoices/${invoiceId}/xml`);
    return blob;
}
